
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/free-trial",
      function () {
        return require("private-next-pages/auth/free-trial/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auth/free-trial"])
      });
    }
  